// extracted by mini-css-extract-plugin
export default {"layer":"style_layer__miJDc"};